<p-card [header]="title" class="h-100">
  <ng-content></ng-content>
</p-card>
